import React from 'react'
import { Grid, Flex, Text } from '@chakra-ui/react'
import { PanelProps } from '~editor/ComponentLibrary'
import PanelComponentDecorator from '../../PanelComponentDecorator'
import ComponentPreview from '~editor/ComponentLibrary/ComponentPreview'
import { PuzzleIcon } from '~editor/components/icons'

export const Buttons: React.FC<PanelProps> = ({ onClose, components }) => {
  return (
    <>
      {components?.length ? (
        <Flex justifyContent={'center'}>
          <Grid
            padding="30px 0"
            templateColumns="234px 234px 234px"
            gridAutoRows="152px"
            alignItems="center"
            gap="25px"
            margin="0 auto"
          >
            {components.map(([id, component]) => {
              return (
                <PanelComponentDecorator key={id} component={component}>
                  <ComponentPreview component={component} onClose={onClose} />
                </PanelComponentDecorator>
              )
            })}
          </Grid>
        </Flex>
      ) : (
        <Flex
          width={'440px'}
          maxWidth={'100%'}
          height={'100%'}
          alignItems={'center'}
          justifyContent={'center'}
          flexDirection={'column'}
          margin={'0 auto'}
          textAlign={'center'}
          fontFamily={'Proxima Nova'}
        >
          <PuzzleIcon fontSize={'79px'} color={'gameglass.50'} />
          <Text
            fontSize={'26px'}
            fontWeight={'700'}
            marginTop={'30px'}
            marginBottom={'15px'}
          >
            {'No Recent Components'}
          </Text>
          <Text fontSize={'14px'} color={'ui.text.grey'}>
            {
              'You have no recently selected components. Choose a category from the list to the left to add some!'
            }
          </Text>
        </Flex>
      )}
    </>
  )
}

export default Buttons
